module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-touch', {
    staticClass: "day-cal__overlay",
    style: ({
      height: _vm.height + 'px'
    })
  }, [_c('div', {
    staticClass: "cal-wrapper",
    style: ({
      height: _vm.calHeight + 'px'
    })
  }, [_c('DCalendar', {
    key: _vm.activeDate + '_' + _vm.locale,
    attrs: {
      "isEditable": false,
      "isShowWeekends": _vm.isShowWeekends,
      "startTime": _vm.startTime,
      "endTime": _vm.endTime,
      "date": _vm.activeDate,
      "events": _vm.lessons,
      "calendarId": _vm.calId,
      "isEventsClickable": true,
      "localeOverride": _vm.locale
    },
    on: {
      "onEventClick": _vm.onTap
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pad-10 weekplan-header marg-20-top"
  }, [_c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.calRangeView))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('calendars.week_plan_and_note.week_plan')))])]), _vm._v(" "), _c('weekplan', {
    staticClass: "pad-10",
    attrs: {
      "weeknote": _vm.weeknote,
      "calId": _vm.calId,
      "date": _vm.date,
      "events": _vm.lessons
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03156f74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Mobile/WeekCal/CalContainer.vue
// module id = 1732
// module chunks = 1